module.exports = __webpack_public_path__ + "static/media/3-BLASTELL.17eab22c.mp3";